import { defineNuxtPlugin } from "nuxt/app";

import { primeVueNoThemePlugin } from "@solvari/components";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(...primeVueNoThemePlugin);
});
